import {KeySnapshot, KeyVault} from "../../api/Model";
import {SetState} from "../../util/FormHandlers";
import {FieldErrors} from "../form-validation/useFormValidation";
import React from "react";
import {Grid} from "@mui/material";
import {filterSerializer} from "../../util/FilterSerializer";
import {TextSearchFilter} from "../filter-fields/TextSearchFilter";
import {KeyVaultFilter} from "../filter-fields/KeyVaultFilter";
import {andFilter, applyFilter, filterText} from "../../util/FilterUtil";

export interface KeySelectTableFilterForm {
    keyVault: KeyVault;
    searchText: string;
}

export const keySelectTableFilterFormSerializer = (defaultKeyVault: KeyVault, keyVaults: KeyVault[]) => filterSerializer<KeySelectTableFilterForm>(
    {
        keyVault: defaultKeyVault,
        searchText: '',
    },
    b => {
        b.keyVault('keyVault', keyVaults);
        b.str('searchText');
    }
);

export function KeySelectTableFilter({form, setForm, fieldErrors}: {
    form: KeySelectTableFilterForm,
    setForm: SetState<KeySelectTableFilterForm>,
    fieldErrors: FieldErrors<'key-vault'>,
}) {
    return (
        <Grid container spacing={2}>
            <KeyVaultFilter filter={form} setFilter={setForm} fieldErrors={fieldErrors}/>
            <TextSearchFilter filter={form} setFilter={setForm} property="searchText"/>
        </Grid>
    );
}

export function filterKeySelectTable(keys: KeySnapshot[], filter: KeySelectTableFilterForm) {
    return applyFilter(keys, andFilter(
        filterText(filter.searchText, keySnapshot => [
            keySnapshot.key.keyNumber,
            keySnapshot.historyRecord.location.type === 'with-guest' ? (
                keySnapshot.historyRecord.location.fullName
            ) : null,
            keySnapshot.historyRecord.location.type === 'with-employee' ? (
                keySnapshot.historyRecord.location.employee.fullName
            ) : null,
        ])
    ));
}
